"use strict";
var app;

function Representative() {
	this.init();
};

Representative.prototype.init = function(){
	var self = this;
	self.fileName();
	self.filter();
	self.resultFilter();
	self.validateStage();
	self.citiesRepresentative();
};

Representative.prototype.citiesRepresentative = function(){
	var self = this;
	$('#representativeRegister select[name="state"]').change(function(event) {
		var sel = $(this);
		$.ajax({
			url: sel.attr('data-ajax'),
			type: 'POST',
			dataType: 'html',
			data: {state: sel.val(), '_token': $('meta[name="csrf-token"]').attr('content')},
			error: function(){
				console.error('error get cities');
			},
			success: function(html){
				$('#representativeRegister select[name="city"]').html(html);
			}
		});
	});
}

Representative.prototype.fileName = function(){
	$('.fileRepresentative').change(function(e){
		let fileName = e.target.files[0].name;
		$('.form__fileName').text(fileName);
	});
}

Representative.prototype.filter = function(){
	let nation = $('select[name=nation]');
	let state = $('#findRepresentative select[name=state]');
	let city = $('#findRepresentative select[name=city]');
	let unity = $('select[name=unity]');
	let operation = $('select[name=operation]');
	let segment = $('select[name=segment]');
	let btnRepresentative = $('.btnRepresentative');
	let disabled = 'disabled';
	$('.form__select').change(function(){
		const verifyNation = nation.val() !== '';
		const verifyState = state.val() !== '';
		const verifyCity = city.val() !== '';
		const verifyUnity = unity.val() !== '';
		const verifyOperation = operation.val() !== '';

		(verifyNation) ? state.removeAttr(disabled) : state.attr(disabled, true).val('');
		(verifyState && verifyNation) ? city.removeAttr(disabled) : city.attr(disabled, true).val('');
		(verifyState && verifyNation && verifyCity) ? unity.removeAttr(disabled) : unity.attr(disabled, true).val('');
		if(verifyState && verifyNation && verifyCity && verifyUnity ) {
			operation.removeAttr(disabled);
			btnRepresentative.removeAttr(disabled);
		} else{
			operation.attr(disabled, true).val('');
			btnRepresentative.attr(disabled, true);
		}
		(verifyState && verifyNation && verifyCity && verifyUnity && verifyOperation) ? segment.removeAttr(disabled) : segment.attr(disabled, true).val('');
	})

	function listOptions(elChange, select, listSelect, valDefault){
		let content = `<option value="">${valDefault}</option>`;
		select.html(content);
		if (elChange.val() !== '') {
			$.ajax({
				type: "POST",
				url: $('#findRepresentative .form').attr('selects-action'),
				data: ($('#findRepresentative .form').serialize()+'&val='+elChange.val()+'&name='+elChange.attr('name')),
				dataType: "json",
				success: function (data) {
					$.each(data[listSelect], (index, el) => {
						content += `<option value="${el.id}">${el.name}</option>`;
					})
					select.html(content);
				}
			});
		}
	}

	nation.change(function(){
		listOptions(nation, state, 'states', jsi18n.state);
		city.attr('disabled', true).val('');
		unity.attr('disabled', true).val('');
		operation.attr('disabled', true).val('');
		segment.attr('disabled', true).val('');
		$('.btnRepresentative').attr('disabled', true);
	});

	state.change(function(){
		listOptions(state, city, 'cities', jsi18n.city)
		unity.attr('disabled', true).val('');
		operation.attr('disabled', true).val('');
		segment.attr('disabled', true).val('');
		$('.btnRepresentative').attr('disabled', true);
	});

	city.change(function(){
		listOptions(city, unity, 'units', jsi18n.business_unit)
		operation.attr('disabled', true).val('');
		segment.attr('disabled', true).val('');
		$('.btnRepresentative').attr('disabled', true);
	});

	unity.change(function(){
		listOptions(unity, operation, 'operations', jsi18n.operation)
		segment.attr('disabled', true).val('');
	});

	operation.change(function(){
		listOptions(operation, segment, 'segments', jsi18n.segment)
	});
}

Representative.prototype.resultFilter = function(){
	$('#findRepresentative .form').on('submit', function(e){
		e.preventDefault();
		$('body').css('opacity', '0.5');
		$.ajax({
			type        : $(this).attr('method'),
			url         : $(this).attr('action'),
			data        : $(this).serialize(),
			dataType    : "json",
			success:function(data) {
				let content = '';
				$.each(data.contents, function(key, el){
					let phones = '';
					$.each(el.phones, function(index, phone){
						phones += `<p class="resultRepresentative__text">${phone}</p>`;
					})
					content += `<div class="resultRepresentative">
												<div class="resultRepresentative__iten" data-aos="fade-up">
													<h2 class="resultRepresentative__title">${el.title}</h2>
													<p class="resultRepresentative__text">${el.subtitle}</p>
													<div class="resultRepresentative__phones">Telefone(s): ${phones}</div>
													<p class="resultRepresentative__text">E-mail(s): <strong>${el.email}</strong></p>
													<hr>
													<div class="resultRepresentative__city ${el.city ? '' : 'd-none'}">
														<p class="resultRepresentative__text"><strong>Cidades atendidas:</strong></p>
														<p class="resultRepresentative__text">${el.city}</p>
													</div>
												</div>
											</div>`;
				})
				$('#findRepresentative .contentRepresentative').html(content).slideDown();
			},
			complete: function(){
				$('body').css('opacity', '1');
			}
		});
	})
}

Representative.prototype.validateStage = function(){
	let hrefCarousel = '#carouselExampleIndicators';
	function validateSelect (btnNext) {
		let elementRequired = btnNext.closest('.carousel-item').find('*:required');
		let count = 0;
		$.each(elementRequired, function(key, el){
			if ( $(el).val() === '' ) {
				count++;
			}
		})
		if (count === 0) {
			btnNext.attr('href', hrefCarousel);
		} else{
			btnNext.attr('href', '');
			Swal.fire({
				title: "OPS!",
				text: 'Algum dado está incorreto ou não foi preenchido. Tente novamente!',
				imageUrl: site_url + 'site/img/iconError.png',
				imageWidth: 76,
				imageHeight: 76
			});
		}
	}
	$('.carousel-control-next').click(function(e){
		e.preventDefault();
		validateSelect($(this));
	})
}

$(document).ready(function(){
	app = new Representative();
});